import axios from 'axios';
import React, { useState } from 'react';
import { useQuery } from 'react-query';

export default function Categories() {
  const [Isloading, setIsloading] = useState(false)

  async function GetAllCategories() {
    setIsloading(true);
    try {
      const response = await axios.get("https://ecommerce.routemisr.com/api/v1/categories");
      return response.data;
    } catch (error) {
      console.error("Error fetching categories:", error);
      return null;
    } finally {
      setIsloading(false);
    }
  }
  const data  = useQuery('categories', GetAllCategories);

  async function GetSubCategories(id) {
    if (!id) {
      return null; // Return null or handle the error case appropriately
    }
    return axios.get(`https://ecommerce.routemisr.com/api/v1/categories/${id}/subcategories`);
  }


  console.log(data)
  const [selectedCardId, setSelectedCardId] = useState(null);
  const [label, setlabel] = useState(" ");
   console.log(label)
  const response = useQuery('subcategories', () => GetSubCategories(selectedCardId), {
    enabled: !!selectedCardId,
    refetchInterval :100,
  });

  // console.log(response);
  // console.log(response.data);

  return (
    <div className='container'>
        {Isloading ?(
          <div className='d-flex align-items-center justify-content-center my-5 py-5 text-center loader-row '>
        <div className="col-auto">
        <div className ="preloader">
	<svg className ="cart" role="img" aria-label="Shopping cart line animation" viewBox="0 0 128 128" width="128px" height="128px" xmlns="http://www.w3.org/2000/svg">
		<g fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="8">
			<g className ="cart__track" stroke="hsla(0,10%,10%,0.1)">
				<polyline points="4,4 21,4 26,22 124,22 112,64 35,64 39,80 106,80" />
				<circle cx="43" cy="111" r="13" />
				<circle cx="102" cy="111" r="13" />
			</g>
			<g className ="cart__lines" stroke="currentColor">
				<polyline className ="cart__top" points="4,4 21,4 26,22 124,22 112,64 35,64 39,80 106,80" stroke-dasharray="338 338" stroke-dashoffset="-338" />
				<g className ="cart__wheel1" transform="rotate(-90,43,111)">
					<circle className ="cart__wheel-stroke" cx="43" cy="111" r="13" stroke-dasharray="81.68 81.68" stroke-dashoffset="81.68" />
				</g>
				<g className ="cart__wheel2" transform="rotate(90,102,111)">
					<circle className ="cart__wheel-stroke" cx="102" cy="111" r="13" stroke-dasharray="81.68 81.68" stroke-dashoffset="81.68" />
				</g>
			</g>
		</g>
	</svg>
</div>

        </div>
      </div>):
      ( <> <div className='row pt-5 g-4'>
      {data?.data?.data.map((categories, index) => (
        <div key={index} className='col-md-4' onClick={() => setSelectedCardId(categories._id)}>
          <div className="card categories"  onClick={() => setlabel(categories.name)}>
            <div className="cardImage">
              <img src={categories.image} className='w-100 img-fluid ratio-4x3 categories_img' style={{ height: 250 }}/>
            </div>
            <div className="cardBody text-center">
              <p className='categore_name'>{categories.name}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
    <div className='row pt-5'>
   {
    {label} ==" "? <h2> </h2> :  <h2 className='text-center subtitle'>{label} Subcategories</h2> }        
    </div>
  <div className='row pt-2 g-4 pb-4'>
  {response?.data?.data.data.map((subcat, index) => (
        <div key = {index} className="col-md-4">
          <div className="card py-2 subcard">
            <p>{subcat.name}</p>
          </div>
        </div>
      ))}
  </div>
  </> )
  }

      </div>
  );
}